import events from 'events.js';
import ko from 'knockout';

function defaultShowNotification(value) {
    return !value;
}

ko.extenders.showNotification = function(target, option) {
    if (typeof option === 'function') {
        target.showNotification = option;
    } else {
        target.showNotification = defaultShowNotification;
    }
};

ko.extenders.notificationMessage = function(target, option) {
    target.notificationMessage = option;
};

ko.extenders.notificationElement = function(target, option) {
    (async function() {
        await events.ready();
        target.notificationElement = option;
    })();
};

ko.bindingHandlers.notificationElement = {
    init(element, valueAccessor) {
        const value = valueAccessor();
        // If showNotification is a function, turn notification on / off
        // based on value returned when called with observable value
        // If it's the bool true, show notification when there's no value
        function updateNotification(v) {
            const show = value.showNotification(v);

            if (show) {
                element.classList.add('-notification');
            } else {
                element.classList.remove('-notification');
            }
        }
        const sub = value.subscribe(updateNotification);

        // Show notifications immediately, if needed
        updateNotification(value());
        ko.utils.domNodeDisposal.addDisposeCallback(
            element,
            sub.dispose.bind(sub),
        );
    },
};
